<template>
    <div>
        <zhaoshangdanao ></zhaoshangdanao>
    </div>
</template>

<script>
import zhaoshangdanao from './components/zhaoshangdanao.vue';

export default {
    name: 'HomePage',
    components: {
        zhaoshangdanao,
        
    },
    data() {
        return {
            userdata: {},
            curWebsite: this.$api.getWebsiteType(),
        };
    },

};
</script>

<style scoped>
/* Your styles go here */
</style>